module.exports = __webpack_public_path__ + "img/research.8b2301c8.gif";